import React,{Fragment, Component} from "react";
import{BrowserRouter as Router,Route,Switch,withRouter} from "react-router-dom";
import {Container,Row,Col,Spinner} from  "react-bootstrap"

// import Header from "./components/header";
import{Header,Banner,Slider, Services, GetInTouch,Footer} from "./components/";

import {GET_WEBSITE_TEMPLATE_DATE} from "./Actions/ApiUrls";
import Axios from "./Actions/Axios";
import Routers from "./Routers"


class Main extends Component{
    constructor(props){
        super(props);
        this.state={
            details:""
        }
        
    }

    componentDidMount(){
        Axios.get(GET_WEBSITE_TEMPLATE_DATE)
        .then(res=>{
            res=res.data;
            
            if(res.status === 1){
                this.setState({
                    details:res.data
                })
            }
        })
        .catch(err=>{
            console.log(err)
        })

    }

    render(){
       const data=this.state.details;
        return (
            <Fragment>
                
                {data && data.email ? (
                    <Fragment>
                        <Header />
                        <Routers data={data} />
                        <Footer data={data}/>
                    </Fragment>
                ):(
                    <Fragment>
                        <div clasName="spiner-loading" style = {{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"} }>

                        <Spinner animation="grow" />
                        </div>
                    </Fragment>
                )}
              
          
            
           
            </Fragment>
        )
    }
}

export default withRouter(Main);